import { Star } from "@shared/assets/icons";
import { useMemo } from "react";

export type RatingDotsProps = {
  rating: number; // [0, 1] all Inclusive;
  dots: number;
};

function Dot({ index, ratingInDots }: { index: number; ratingInDots: number }) {
  const value = useMemo(
    () => Math.max(Math.min(ratingInDots - index, 1), 0),
    [index, ratingInDots]
  );

  return (
    <div className="relative w-4 h-4 aspect-square overflow-hidden">
      <Star className={"w-4 h-4 fill-white"} />

      <Star
        className={"absolute left-0 top-0 w-4 h-4 fill-antique-brass-500"}
        style={{ clipPath: `inset(0 ${100 - value * 100}% 0 0)` }}
      />
    </div>
  );
}

export function RatingDots({ rating, dots }: RatingDotsProps) {
  const ratingInDots = useMemo(() => rating * dots, [dots, rating]);

  return (
    <div className={"flex gap-2 items-center justify-center"}>
      {Array.from({ length: dots }).map((_, index) => (
        <Dot key={index} index={index} ratingInDots={ratingInDots} />
      ))}
    </div>
  );
}
